import isEmpty from 'lodash-es/isEmpty'

export const keywordsTruncate: (
  title: string,
  keywords: string[],
  options?: {
    maxInitialChars?: number
    maxHeadChars?: number
    maxTailChars?: number
    isRetainWords?: boolean
  },
) => string = (title, keywords: string[], options = {}) => {
  const {
    maxInitialChars = 30,
    maxTailChars = 20,
    maxHeadChars = 20,
    isRetainWords = false,
  } = options

  if (isEmpty(keywords)) {
    return title
  }

  const hitKeywordList = keywords
    .map((keyword) => {
      return title.toLowerCase().indexOf(keyword.toLowerCase())
    })
    .filter((index) => index !== -1)
  if (hitKeywordList.length === 0) {
    return title
  }

  const firstFoundIndex = Math.min(...hitKeywordList)
  if (firstFoundIndex < maxInitialChars) {
    return title
  }

  const tailRange = title.length - firstFoundIndex
  const startIndex = Math.max(0, firstFoundIndex - maxHeadChars)
  const endIndex = firstFoundIndex + maxTailChars

  let truncatedTitle =
    tailRange < maxInitialChars
      ? title.slice(title.length - maxInitialChars)
      : title.slice(startIndex, endIndex)

  // 確保開頭不截斷完整英文單詞
  if (startIndex > 0 && isRetainWords) {
    const startTrimmedTitle = title.slice(startIndex)
    const firstWordBoundary = startTrimmedTitle.search(/\s|$/)
    if (firstWordBoundary < maxTailChars) {
      truncatedTitle = title.slice(startIndex + firstWordBoundary + 1, endIndex)
    }
  }

  return truncatedTitle
}
